import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../utils'
import { getAPIURL, getJioFinHubHeader } from '../config'

const formatMetaData = (emiData: any) => {
  const metaDataList = emiData?.metadata?.instrumentMetaDataList ?? []
  const map = new Map(metaDataList?.map(({ name }: any) => [name, { data: { validations: [] } }]))
  for (let { name, errorMessage, validationPattern, ...metaData } of metaDataList) {
    if (!metaData?.usage?.includes('validation')) {
      ;(map.get(name) as any).data = {
        ...(map.get(name) as any).data,
        name,
        ...metaData,
      }
    }
    ;(map.get(name) as any).data.validations.push({ validationPattern, errorMessage, label: metaData?.label })
  }
  const copy = Object.assign({}, emiData)
  copy.metadata = [...map.values()].filter(({ data }) => data.name).map(({ data }) => data)
  copy.routingId = emiData?.metadata?.routingId
  return copy
}

const formatBankEmiPlans = (emiPlans: [any]) => {
  emiPlans = emiPlans.sort((a, b) => {
    return a.value - b.value
  })
  const map = new Map(
    emiPlans.map(({ bankId, bankName, planSource }) => [bankId, { bankId, bankName, planSource, emiPlans: [] }]),
  )
  for (let { bankId, ...bankData } of emiPlans) {
    map.get(bankId).emiPlans.push(formatMetaData({ bankId, ...bankData }))
  }
  return [...map.values()]
}

const responseParser = (data: any, TYPE: string, isSecondEligibilityCall: boolean) => {
  if (isStatusOK(data)) {
    const availablePaymentDetails = data?.data?.[TYPE]
    const banksEmiPlansRaw = availablePaymentDetails?.[TYPE + 'Plans']
    const banksRequiedAdditionalInfoRaw = availablePaymentDetails?.[TYPE + 'Banks']

    if (isSecondEligibilityCall) {
      if (availablePaymentDetails && banksEmiPlansRaw) {
        const emiPlans = banksEmiPlansRaw?.map((emiPlan: any) => {
          return formatMetaData(emiPlan)
        })
        return { planSource: banksEmiPlansRaw?.[0]?.planSource, emiPlans }
      } else {
        throw { message: 'No Plans Available for selected instrument', code: -1 }
      }
    } else {
      if (banksEmiPlansRaw || banksRequiedAdditionalInfoRaw) {
        const banksRequiedAdditionalInfo = banksRequiedAdditionalInfoRaw?.map((item: any) => {
          return formatMetaData(item)
        })
        const banksEmiPlans = formatBankEmiPlans(banksEmiPlansRaw)
        return {
          amountPayable: data?.data?.amount?.netAmount,
          banksRequiedAdditionalInfo,
          banksEmiPlans,
          eligibilityResponseID: data?.data?.eligibilityResponseID,
        }
      } else {
        throw { message: 'No Plans Available for selected instrument', code: -1 }
      }
    }
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const checkEligibilityApi = (body: any, TYPE: string, isSecondEligibilityCall: boolean) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('eligibilityApi')}`,
    method: 'POST',
    headers: getJioFinHubHeader(),
    body,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data, TYPE, isSecondEligibilityCall)
  })
}

export const getEligibilityApiReq: any = (mobNo: any, bankId: string, metaData: any, TYPE: any) => {
  return {
    entity: {
      initiatingEntityId: RootStore?.transaction?.initiatingEntity?.entityId,
      application: RootStore?.transaction?.id?.application,
      type: 12, //HTAG TODO
      entityId: RootStore?.merchant?.id,
    },
    user: {
      externalId: RootStore.user.externalId,
      mobile: {
        number: mobNo,
        countryCode: '91',
      },
      type: 11, //HTAG TODO
    },
    amount: {
      netAmount: RootStore.transaction.amount.netAmount,
    },
    metadata: metaData,
    queryParameters: {
      method: {
        type: 114,
        subType: SUBTYPES[TYPE], //HTAG TODO
      },
      bankId: bankId, //HTAG TODO
    },
  }
}

export const SUBTYPES: any = {
  creditCardEmi: '581',
  debitCardEmi: '592',
  cardlessEmi: '618',
  payLaterEmi: '617',
}
